import { required } from 'AppReact/schema';

export default {
    id: required('integer'),
    name: required('string'),
    creator: required('string'),
    property_id: required('integer'),
    document_id: required('integer'),
    property_name: required('string'),
    type: required('string'),
    url: required('string')
}